import { render, staticRenderFns } from "./install-mobile-app.vue?vue&type=template&id=2eb678e8&"
import script from "./install-mobile-app.vue?vue&type=script&lang=js&"
export * from "./install-mobile-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports